import styled from 'styled-components';

import { min } from '../utils/breakpoints';
import textOrPlaceholder from '../utils/textOrPlaceholder';

import StyledTable from './Styled/StyledTable';

const StyledRateLabel = styled.span`
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  background-color: ${(props) => props.bgColor};
  border: 1px solid ${(props) => props.borderColor ?? props.theme.colors.white};
  color: ${(props) => props.color ?? props.theme.colors.dark};
  padding: 4px 8px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: bold;
  font-size: 10px;
  margin-top: 10px;

  ${min.sm} {
    font-size: 12px;
  }
`;

const StyledRateDescription = styled.p`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: ${(props) => props.theme.standardLayout.savings.rateDescription.fontSize};
  line-height: ${(props) => props.theme.standardLayout.savings.rateDescription.lineHeight};

  ${min.sm} {
    font-size: ${(props) => props.theme.standardLayout.savings.rateDescription.fontSize};
  }
`;

const printTariffRate = (rate) => {
  let rateText = `${textOrPlaceholder(rate.minRate, rate.minRate?.toFixed(1))}`;

  if (rate.minRate !== rate.maxRate) {
    rateText += ` - ${textOrPlaceholder(rate.maxRate, rate.maxRate?.toFixed(1))}`;
  }

  return rateText;
};

const TariffRateTableRow = ({ category, importRate, exportRate, content, columns = [] }) => {
  if (!importRate?.minRate && !exportRate?.minRate) return null;

  return (
    <tr key={category}>
      <StyledTable.Td>
        <StyledRateLabel color={content.color} bgColor={content.bgColor} borderColor={content.borderColor}>
          {content.heading}
        </StyledRateLabel>
        <StyledRateDescription>{content.description}</StyledRateDescription>
      </StyledTable.Td>

      {columns.includes('import') && <StyledTable.Td center>{printTariffRate(importRate)}</StyledTable.Td>}

      {columns.includes('export') && <StyledTable.Td center>{printTariffRate(exportRate)}</StyledTable.Td>}
    </tr>
  );
};

export default TariffRateTableRow;
